import { Component } from "react";
import { getTokenOrRefresh } from "./token_util";
import { ResultReason } from "microsoft-cognitiveservices-speech-sdk";

const speechsdk = require('microsoft-cognitiveservices-speech-sdk')

// 将创建 sdkSpeech 和 sdkRecognizer 对象
async function createRecognizers(tokenObj, speechLanguage) {
  const speechConfig = speechsdk.SpeechConfig.fromAuthorizationToken(
    tokenObj.authToken,
    tokenObj.region
  );

  // 设置默认语音识别语言
  speechConfig.speechRecognitionLanguage = speechLanguage;

  const audioConfig = speechsdk.AudioConfig.fromDefaultMicrophoneInput();
  const sdkSpeech = new speechsdk.SpeechRecognizer(speechConfig, audioConfig);
  const sdkRecognizer = new speechsdk.ConversationTranscriber(speechConfig, audioConfig);    

  return { sdkSpeech, sdkRecognizer };
}


export default class Voice extends Component {    
  constructor(props) {
    super(props);

    this.state = {
        displayText: 'INITIALIZED: ready to test speech...'
    }
  }
  
  async componentDidMount() {
    // check for valid speech key/region
    const tokenRes = await getTokenOrRefresh();
    if (tokenRes.authToken === null) {
        this.setState({
            displayText: 'FATAL_ERROR: ' + tokenRes.error
        });
    }
  }

  async sttFromMic(setRealTimeText, isRecordingRef, shiftSpeechLanguageRef, setRecognizedText, setSpeaker, speechLanguage="zh-CN", isPro=false) {
    console.log("ispro: ", isPro, shiftSpeechLanguageRef, isRecordingRef);

    function setupEventHandlers() {
      sdkSpeech.recognizing = (s, e) => {
        // 检查 isRecordingRef 的值
        if (!isRecordingRef.current || shiftSpeechLanguageRef.current) {
          stopRecording();
        }
  
        if (e.result.reason === speechsdk.ResultReason.RecognizingSpeech) {
          setRealTimeText(e.result.text);
        }
      };
  
      sdkRecognizer.transcribed = (s, e) => {
        if (e.result.reason === speechsdk.ResultReason.RecognizedSpeech) {
          console.log(e.result.text);
          
          setRecognizedText(e.result.text);
          setSpeaker(e.result.speakerId);
        } else if (e.result.reason === speechsdk.ResultReason.NoMatch) {
          // console.log("NOMATCH: Speech could not be recognized.");
        }
        // 检查 isRecordingRef 的值
        if (!isRecordingRef.current || shiftSpeechLanguageRef.current) {
          stopRecording();
        }
      };
    }    

    console.log("shiftSpeechLanguageRef: ", shiftSpeechLanguageRef.current);
    
    if( shiftSpeechLanguageRef.current) {
      console.log("切换语言：\n", "isRecordingRef.current: "+isRecordingRef.current,
        "\nshiftSpeechLanguageRef.current: "+shiftSpeechLanguageRef.current,
        "\nspeechLanguage: "+speechLanguage,
      );
    }

    let tokenObj = await getTokenOrRefresh("new", null, isPro);
    // console.log("tokenObj: ", tokenObj);

    let { sdkSpeech, sdkRecognizer } = await createRecognizers(tokenObj, speechLanguage);
    setupEventHandlers();

    function stopRecording() {
      sdkSpeech.stopContinuousRecognitionAsync();
      sdkRecognizer.stopTranscribingAsync();
    }

    // 检查 isRecordingRef 和 shiftSpeechLanguageRef 的值
    if (!isRecordingRef.current || shiftSpeechLanguageRef.current) {
      stopRecording();
    }
    
    // 实时语音 捕捉错误
    sdkSpeech.canceled = async (s, e) => {
      if (e.reason === speechsdk.CancellationReason.Error) {
        console.log(`CANCELED: ErrorCode=${e.errorCode}`);
        console.log(`CANCELED: ErrorDetails=${e.errorDetails}`);
        console.log("CANCELED: Did you update the subscription info?");

        // 停止当前的录音
        stopRecording();
      }

      // 如果 key 的订阅时间到期，换 key
      if (e.errorCode === 2 || e.errorCode === 4) {
        tokenObj = await getTokenOrRefresh("refresh", tokenObj.id, isPro);
        console.log("refresh tokenObj: ", tokenObj);
  
        // // 停止当前的录音
        // stopRecording();

        // 重新创建 sdkSpeech 和 sdkRecognizer 对象，并开始录音
        console.log("该换 key 了");
        const newRecognizers = await createRecognizers(tokenObj, speechLanguage);
        sdkSpeech = newRecognizers.sdkSpeech;
        sdkRecognizer = newRecognizers.sdkRecognizer;
        console.log("获得了新的 key", newRecognizers);
        setupEventHandlers();

        sdkSpeech.startContinuousRecognitionAsync();
        sdkRecognizer.startTranscribingAsync();
        
      } else {    //其他错误重新开始录音
        sdkSpeech.startContinuousRecognitionAsync();
        sdkRecognizer.startTranscribingAsync();
      };
    };
  
    sdkSpeech.sessionStopped = (s, e) => {
      console.log("\n Session stopped event.");  
      stopRecording();
    };
    

    if (isRecordingRef.current && !shiftSpeechLanguageRef.current) {      
      sdkSpeech.startContinuousRecognitionAsync();
      sdkRecognizer.startTranscribingAsync();
    }
  }

  async fileChange(event) {
    const audioFile = event.target.files[0];
    console.log(audioFile);
    const fileInfo = audioFile.name + ` size=${audioFile.size} bytes `;

    this.setState({
      displayText: fileInfo
    });

    const tokenObj = await getTokenOrRefresh();
    const speechConfig = speechsdk.SpeechConfig.fromAuthorizationToken(tokenObj.authToken, tokenObj.region);
    speechConfig.speechRecognitionLanguage = 'en-US';

    const audioConfig = speechsdk.AudioConfig.fromWavFileInput(audioFile);
    const recognizer = new speechsdk.SpeechRecognizer(speechConfig, audioConfig);

    recognizer.recognizeOnceAsync(result => {
      let displayText;
      if (result.reason === ResultReason.RecognizedSpeech) {
        displayText = `RECOGNIZED: Text=${result.text}`
      } else {
          displayText = 'ERROR: Speech was cancelled or could not be recognized. Ensure your microphone is working properly.';
      }

      console.log("displayText: " + displayText, result.text);

      this.setState({
        displayText: fileInfo + displayText
      });
    });
  }
}

// 将 sttFromMic 和 fileChange 方法作为命名导出
export const { sttFromMic, fileChange } = new Voice();